/**
 * @fileoverview Weight data source and type definitions.
 */

import { WeightSchema, type Weight } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createAuditFields, createDateField, createIdField, createJsonField, createStringField, FIELD_WIDTHS } from './field-factories';
import { getCache } from './cache-registry';

export type { Weight };

export const weightDataSource = createBaseDataSource<Weight>({
  endpoint: 'weight',
  searchField: 'recorded_date',
  schema: WeightSchema,
  fields: [
    createIdField(FIELD_WIDTHS.SMALL),
    createDateField('recorded_date', 'Recorded Date', FIELD_WIDTHS.XLARGE),
    {
      field: 'weight_lbs',
      headerName: 'Weight (lbs)',
      type: 'number',
      width: FIELD_WIDTHS.SMALL,
      editable: true,
    },
    {
      field: 'weight_kg',
      headerName: 'Weight (kg)',
      type: 'number',
      width: FIELD_WIDTHS.SMALL,
      editable: false,
    },
    {
      field: 'weight_st',
      headerName: 'Weight (st)',
      type: 'number',
      width: FIELD_WIDTHS.SMALL,
      editable: false,
    },
    createStringField('notes', 'Notes', FIELD_WIDTHS.XLARGE),
    createJsonField('metadata', 'Metadata', FIELD_WIDTHS.XLARGE),
    ...createAuditFields(),
  ],
});

export const weightCache = getCache('weight');
